import "../css/header.scss";
import React, { useContext, useRef } from "react";
import { Link } from "react-router-dom";
import { CartContext } from "./CartContext";
import { FiShoppingCart } from "react-icons/fi";

function Header() {
  const { cartItems } = useContext(CartContext);
  const moreMenuRef = useRef(null);

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const closeMoreMenu = () => {
    moreMenuRef.current?.removeAttribute("open");
    toTop();
  };

  return (
    <header className="site-header">
      {/* Top Banner */}
      <div className="top-banner">
        <div className="banner-content">
          New Hardware Collections: ESBEN & PEYTON ✨
        </div>
      </div>

      {/* Main Header */}
      <div className="header-main">
        <div className="header-container">
          <div className="header-left"></div>

          <div className="header-center">
            <Link to="/" className="logo" onClick={toTop}>
              <img
                src="/head/pedarcircle-mark.svg"
                alt="Pedarcircle"
                className="logo-mark"
              />
            </Link>
          </div>

          <div className="header-right">
            <Link
              to="/cartpage"
              className="icon-link cart-link"
              onClick={toTop}
            >
              <FiShoppingCart />
              {cartItems?.length > 0 && (
                <span className="cart-count">{cartItems.length}</span>
              )}
            </Link>
          </div>
        </div>
      </div>

      {/* Navigation */}
      <nav className="header-nav">
        <ul className="nav-list">
          <li>
            <Link to="/about" onClick={toTop}>
              Our Story
            </Link>
          </li>
          <li>
            <Link to="/contact" onClick={toTop}>
              Contact Us
            </Link>
          </li>
          <li>
            <Link to="/shop" onClick={toTop}>
              Sale
            </Link>
          </li>
          <li className="more-nav-item">
            <details className="more-menu" ref={moreMenuRef}>
              <summary>More</summary>
              <div className="more-menu-panel">
                <Link to="/faqs" onClick={closeMoreMenu}>
                  FAQs
                </Link>
                <Link to="/shipping" onClick={closeMoreMenu}>
                  Shipping Policy
                </Link>
                <Link to="/returns" onClick={closeMoreMenu}>
                  Refund Policy
                </Link>
                <Link to="/privacy" onClick={closeMoreMenu}>
                  Privacy Policy
                </Link>
                <Link to="/cookies" onClick={closeMoreMenu}>
                  Cookie Policy
                </Link>
                <Link to="/terms" onClick={closeMoreMenu}>
                  Terms &amp; Conditions
                </Link>
              </div>
            </details>
          </li>
        </ul>
      </nav>
    </header>
  );
}

export default Header;
